import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import MainLayout from "../components/MainLayout";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { PayrollHeader } from "../components/HeaderAttribute";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import SalaryPaidPopup from "../popup-containers/SalarypaidPopup";

const SalaryPaid = () => {
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [MstSalaryPaidId, setMstSalaryPaidId] = useState(0);
  const [rowIndex, setRowIndex] = useState(null);
  const [bindSalaryPaidGridDatas, setbindSalaryPaidGridDatas] = useState([]);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [staffNameDD, setStaffNameDD] = useState([]);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popupDataDD, setPopupDataDD] = useState([]);
  const [bindSalaryPaidData, setbindSalaryPaidData] = useState([]);

  const [formFields, setFormFields] = useState({
    staffName: "",
    salaryDate: "",
    grade: "",
    MstGradeId: 0,
    basicSalary: "0",
    da: "0",
    hra: "0",
    convenience: "0",
    medical: "0",
    performance: "0",
    others: "0",
    grossSalaryTotal: "0",
    pf: "0",
    esi: "0",
    insurance: "0",
    loan: "0",
    tax: "0",
    deductionsTotal: "0",
    nettotal: "0",
    workingDays: "",
    presentDays: "",
    leaveDays: "",
    absentDays: "",
    totalAmounttobePaid: ""
  });

  const [formFieldsError, setFormFieldsError] = useState({
    dateError: "",
    staffNameError: "",
    salaryGradeError: "",
    presentDays: "",
    leaveDays: "",
    absentDays: "",
    workingDays: ""
  });

  const createdBy = sessionStorage.getItem("createdBy");

  const requiredFields = [
    { field: "salaryDate", type: "date" },
    { field: "staffName", type: "select-one" },
    { field: "grade", type: "input" },
    { field: "workingDays", type: "input" },
    { field: "presentDays", type: "input" },
    { field: "leaveDays", type: "input" },
    { field: "absentDays", type: "input" },
  ];

  const fieldLabels = {
    salaryDate: "Date",
    staffName: "Staff Name",
    grade: "Grade",
    workingDays: "Working Days",
    presentDays: "Present Days",
    leaveDays: "Leave Days",
    absentDays: "Absent Days"
  };

  const calculateTotalAmountToBePaid = (fields = formFields) => {
    const netTotal = parseFloat(fields.nettotal) || 0;
    const workingDays = parseFloat(fields.workingDays) || 0;
    const presentDays = parseFloat(fields.presentDays) || 0;
    const leaveDays = parseFloat(fields.leaveDays) || 0;

    if (workingDays <= 0) return "0";

    const paidDays = presentDays + leaveDays;
    const dailySalary = netTotal / workingDays;
    const totalAmount = (dailySalary * paidDays).toFixed(2);

    return totalAmount;
  };



  const handleFieldsChange = async (value, name) => {
    if (name === "staffName") {
      if (value) {
        setFormFields(prev => ({
          ...prev,
          staffName: value,
          grade: "",
          basicSalary: "0",
          da: "0",
          hra: "0",
          convenience: "0",
          medical: "0",
          performance: "0",
          others: "0",
          grossSalaryTotal: "0",
          pf: "0",
          esi: "0",
          insurance: "0",
          loan: "0",
          tax: "0",
          deductionsTotal: "0",
          nettotal: "0",
          workingDays: "",
          presentDays: "",
          leaveDays: "",
          absentDays: "",
          totalAmounttobePaid: ""
        }));
        await BindSalaryPaidData(value);
      } else {
        resetSalaryForm();
      }
    } else {
      setFormFields(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };


  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `Enter the ${formattedName}.` : "",
    }));
  };

  const validateForm = () => {
    
    const newErrors = {};
    let isValid = true;

    requiredFields.forEach(({ field, type }) => {
      const value = formFields[field];
      let isEmpty = false;

      if (type === 'select-one') {
        isEmpty = value === "" || value === '0';
      } else {
        isEmpty = value === undefined || value === "" || value.toString().trim() === '';
      }

      if (isEmpty) {
        const label = fieldLabels[field] || field;
        newErrors[field] = `${type === 'select-one' ? 'Select' : 'Enter'} ${label}`;
        isValid = false;
      }
    });

    setFormFieldsError(newErrors);
    return isValid;
  };

  const handleSubmit = async (rowIndex, flag) => {
    
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();
    if (flag === 1 || flag === 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return;
      }

      const data = {
        mstSalaryPaidId: MstSalaryPaidId || 0,
        salaryDate: formFields.salaryDate,
        mstStaffId: formFields.staffName,
        grade: formFields.MstGradeId,
        mstgrade:formFields.MstGradeId,
        basicSalary: formFields.basicSalary,
        da: formFields.da,
        hra: formFields.hra,
        convenience: formFields.convenience,
        medical: formFields.medical,
        performance: formFields.performance,
        others: formFields.others,
        grossSalaryTotal: formFields.grossSalaryTotal,
        pf: formFields.pf,
        esi: formFields.esi,
        insurance: formFields.insurance,
        loan: formFields.loan,
        tax: formFields.tax,
        deductionsTotal: formFields.deductionsTotal,
        netTotal: formFields.nettotal,
        workingDays: formFields.workingDays,
        presentDays: formFields.presentDays,
        leaveDays: formFields.leaveDays,
        absentDays: formFields.absentDays,
        totalAmounttobePaid: formFields.totalAmounttobePaid,
        createdBy: parseInt(createdBy, 10),
        flag: flag,
      };

      const response = await IUDAPI(data, "SalaryPaidAPI/IUDSalaryPaid");

      if (flag === 1) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Salary data saved successfully!");
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to save salary data");
        }
      } else if (flag === 2) {
        if (response.data.Table[0].Result === "M") {
          toast.success("Salary data updated successfully!");
          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to update salary data");
        }
      }
    } else {
      const data = {
        mstSalaryPaidId: MstSalaryPaidId || 0,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(data, "SalaryPaidAPI/IUDSalaryPaid");

      if (flag === 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Salary record deleted successfully!");
        } else {
          toast.error("Failed to delete salary record");
        }
      } else if (flag === 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Salary record blocked successfully!");
        } else {
          toast.error("Failed to block salary record");
        }
      } else if (flag === 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Salary record unblocked successfully!");
        } else {
          toast.error("Failed to unblock salary record");
        }
      }
      setTimeout(cancel, 2000);
    }
  };

  const BindStaffnameData = async () => {
    const response = await BindAPI("SalaryPaidAPI/BindStaffname");
    if (response?.data?.Table) {
      const staffName = response.data.Table.map((item) => ({
        value: item.StaffId.toString(),
        label: item.StaffName,
      }));
      setStaffNameDD(staffName);
    }
  };

  const BindSalaryPaidData = async (staffId) => {
    
    try {
      const response = await BindPostAPI({ MstStaffId: staffId }, "SalaryPaidAPI/BindSalaryPaid");
      if (response?.data?.Table?.[0]) {
        const salaryData = response.data.Table[0];
        const newFormFields = {
          staffName: staffId,
          salaryDate: salaryData.SalaryDate || "",
          grade: salaryData.Grade || "",
          MstGradeId: salaryData.MstGradeId,
          basicSalary: salaryData.BasicSalary?.toString() || "0",
          da: salaryData.DA?.toString() || "0",
          hra: salaryData.HRA?.toString() || "0",
          convenience: salaryData.Convenience?.toString() || "0",
          medical: salaryData.Medical?.toString() || "0",
          performance: salaryData.Performance?.toString() || "0",
          others: salaryData.Others?.toString() || "0",
          grossSalaryTotal: salaryData.GrossSalaryTotal?.toString() || "0",
          pf: salaryData.PF?.toString() || "0",
          esi: salaryData.ESI?.toString() || "0",
          insurance: salaryData.Insurance?.toString() || "0",
          loan: salaryData.Loan?.toString() || "0",
          tax: salaryData.Tax?.toString() || "0",
          deductionsTotal: salaryData.DeductionsTotal?.toString() || "0",
          nettotal: salaryData.NetTotal?.toString() || "0",
          // workingDays: salaryData.WorkingDays?.toString(),
          // presentDays: salaryData.PresentDays?.toString(),
          // leaveDays: salaryData.LeaveDays?.toString(),
          // absentDays: salaryData.AbsentDays?.toString(),
          // totalAmounttobePaid: "0" // will be auto-calculated in useEffect
        };
        setFormFields(newFormFields);
        setbindSalaryPaidData(response);
      } else {
        console.warn("No salary data found for staffId:", staffId);
        resetSalaryForm();
      }
    } catch (error) {
      console.error("Error fetching salary data:", error);
      toast.error("Failed to fetch salary data");
      resetSalaryForm();
    }
  };

  const resetSalaryForm = () => {
    setFormFields({
      staffName: "",
      salaryDate: "",
      grade: "",
      basicSalary: "0",
      da: "0",
      hra: "0",
      convenience: "0",
      medical: "0",
      performance: "0",
      others: "0",
      grossSalaryTotal: "0",
      pf: "0",
      esi: "0",
      insurance: "0",
      loan: "0",
      tax: "0",
      deductionsTotal: "0",
      nettotal: "0",
      workingDays: "",
      presentDays: "",
      leaveDays: "0",
      absentDays: "0",
      totalAmounttobePaid: "0"
    });
  };

  const BindSalaryPaidGridDatas = async () => {
    const response = await BindAPI("SalaryPaidAPI/BindSalaryPaidGrid");
    if (response && response.data) {
      setbindSalaryPaidGridDatas(response.data.Table);
    } else {
      setbindSalaryPaidGridDatas([]);
    }
  };


  const handleEdit = (rowIndex) => {
    
    const data = bindSalaryPaidGridDatas[rowIndex];



    const newFormFields = {
      staffName: data.StaffId?.toString() || "",
      salaryDate: data.SalaryDate.split("T")[0] || "",
      grade: data.SalaryGrade|| "",
      MstGradeId: data.Grade,
      basicSalary: data.BasicSalary?.toString() || "0",
      da: data.DA?.toString() || "0",
      hra: data.HRA?.toString() || "0",
      convenience: data.Convenience?.toString() || "0",
      medical: data.Medical?.toString() || "0",
      performance: data.Performance?.toString() || "0",
      others: data.Others?.toString() || "0",
      grossSalaryTotal: data.GrossSalaryTotal?.toString() || "0",
      pf: data.PF?.toString() || "0",
      esi: data.ESI?.toString() || "0",
      insurance: data.Insurance?.toString() || "0",
      loan: data.Loan?.toString() || "0",
      tax: data.Tax?.toString() || "0",
      deductionsTotal: data.DeductionsTotal?.toString() || "0",
      nettotal: data.NetTotal?.toString() || "0",
      workingDays: data.WorkingDays?.toString() || "",
      presentDays: data.PresentDays?.toString() || "",
      leaveDays: data.LeaveDays?.toString() || "",
      absentDays: data.AbsentDays?.toString() || "",
      totalAmounttobePaid: data.TotalAmounttobePaid?.toString() || "0",
    };

    // Set row index and other UI states
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstSalaryPaidId(data.MstSalaryPaidId);

    // Update formFields and calculate totalAmounttobePaid
    setFormFields({
      ...newFormFields,
      totalAmounttobePaid: calculateTotalAmountToBePaid(newFormFields),
    });
  };
  const handleSalaryPaid = (rowIndex, flag) => {
    
    setpopUpOpen(true);
    setRowIndex(rowIndex);

    const rowData = bindSalaryPaidGridDatas[rowIndex];
    setMstSalaryPaidId(rowData.MstSalaryPaidId);
    setPopUpData(rowData);

    // Set flags for view/edit/block/unblock/delete
    setViewDetails(flag === 1);
    setDeleteDetails(flag === 3);
    setBlockDetails(flag === 4);
    setUnBlockDetails(flag === 5);

    // ✅ Pass actual staff dropdown data
    setPopupDataDD({
      staffName: staffNameDD
    });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setFormFields({
      staffName: "",
      salaryDate: "",
      grade: "",
      MstgradeId: 0,
      basicSalary: "",
      da: "",
      hra: "",
      convenience: "",
      medical: "",
      performance: "",
      others: "",
      grossSalaryTotal: "",
      pf: "",
      esi: "",
      insurance: "",
      loan: "",
      tax: "",
      deductionsTotal: "",
      nettotal: "",
      workingDays: "",
      presentDays: "",
      leaveDays: "",
      absentDays: "",
      totalAmounttobePaid: ""
    });
    BindSalaryPaidGridDatas();

  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setFormFields(prev => ({
      ...prev,
      workingDays: "",
      presentDays: "",
      leaveDays: "0",
      absentDays: "0",
      totalAmounttobePaid: calculateTotalAmountToBePaid()
    }));
  };

  useEffect(() => {
    BindStaffnameData();
    BindSalaryPaidGridDatas();
  }, []);

  useEffect(() => {
    setFormFields(prev => ({
      ...prev,
      totalAmounttobePaid: calculateTotalAmountToBePaid(prev)
    }));
  }, [
    formFields.nettotal,
    formFields.workingDays,
    formFields.presentDays,
    formFields.leaveDays
  ]);
  return (
    <MainLayout pageName={"3"}>
      {visibleTable && (
        <GridPage
          title="Payroll"
          header={PayrollHeader}
          records={bindSalaryPaidGridDatas.map(item => ({
            ...item,
            SalaryDate: formatDate(item.SalaryDate)
          }))}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleSalaryPaid}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Payroll"
            />

            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className="grid gap-4 mb-6 md:grid-cols-3 px-4">
                    <InputText
                      inputType={"date"}
                      title={"Date"}
                      name={"salaryDate"}
                      classStar={"text-red-500"}
                      content={formFields.salaryDate}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          salaryDate: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setFormFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          dateError:
                            formFields.salaryDate && formFields.salaryDate.trim() !== ""
                              ? ""
                              : "Select Salary Date",
                        }));
                      }}
                      errorMessage={formFieldsError.dateError}
                    />
                    <AutoDropDown
                      title="Staff Name"
                      name="staffName"
                      options={staffNameDD}
                      placeholder="Select"
                      selectedOption={staffNameDD.find((x) => x.value === formFields.staffName)}
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prev) => ({
                          ...prev,
                          staffNameError: formFields.staffName ? "" : "Select Staff Name",
                        }));
                      }}
                      errorMessage={formFieldsError?.staffNameError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Grade"}
                      name={"grade"}
                      classStar={"text-red-500"}
                      content={formFields.grade}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          grade: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                  </div>

                  <div className="font-semibold px-4">Gross Salary</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType={"number"}
                      title={"Basic Salary"}
                      name={"basicSalary"}
                      classStar={"text-red-500"}
                      content={formFields.basicSalary}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          basicSalary: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                    <InputText
                      inputType={"number"}
                      title={"DA"}
                      name={"da"}
                      classStar={"text-red-500"}
                      content={formFields.da}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          da: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"HRA"}
                      name={"hra"}
                      classStar={"text-red-500"}
                      content={formFields.hra}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          hra: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Convenyance"}
                      name={"convenience"}
                      classStar={"text-red-500"}
                      content={formFields.convenience}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          convenience: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Medical"}
                      name={"medical"}
                      classStar={"text-red-500"}
                      content={formFields.medical}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          medical: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Performance"}
                      name={"performance"}
                      classStar={"text-red-500"}
                      content={formFields.performance}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          performance: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                    <InputText
                      inputType={"number"}
                      title={"Others"}
                      name={"others"}
                      classStar={"text-red-500"}
                      content={formFields.others}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          others: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Gross Salary Total"}
                      name={"grossSalaryTotal"}
                      classStar={"text-red-500"}
                      content={formFields.grossSalaryTotal}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          grossSalaryTotal: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                  </div>

                  <div className="font-semibold px-4">Deductions</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType={"number"}
                      title={"PF"}
                      name={"pf"}
                      classStar={"text-red-500"}
                      content={formFields.pf}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          pf: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"ESI"}
                      name={"esi"}
                      classStar={"text-red-500"}
                      content={formFields.esi}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          esi: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Insurance"}
                      name={"insurance"}
                      classStar={"text-red-500"}
                      content={formFields.insurance}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          insurance: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                    <InputText
                      inputType={"number"}
                      title={"Loan"}
                      name={"loan"}
                      classStar={"text-red-500"}
                      content={formFields.loan}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          loan: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Tax"}
                      name={"tax"}
                      classStar={"text-red-500"}
                      content={formFields.tax}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          tax: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Deduction Total"}
                      name={"deductionsTotal"}
                      classStar={"text-red-500"}
                      content={formFields.deductionsTotal}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          deductionsTotal: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                    <InputText
                      inputType={"number"}
                      title={"Net Total"}
                      name={"nettotal"}
                      classStar={"text-red-500"}
                      content={formFields.nettotal}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          nettotal: e.target.value,
                        })
                      }
                      disabled={true}
                    />
                  </div>

                  <div className="font-semibold px-4">Attendance Details</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType={"number"}
                      title={"Working Days"}
                      name={"workingDays"}
                      classStar={"text-red-500"}
                      content={formFields.workingDays}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setFormFields({ ...formFields, workingDays: value });

                        // Validate days sum
                        const workingDays = parseFloat(value) || 0;
                        const presentDays = parseFloat(formFields.presentDays) || 0;
                        const leaveDays = parseFloat(formFields.leaveDays) || 0;
                        const absentDays = parseFloat(formFields.absentDays) || 0;
                        const totalDays = presentDays + leaveDays + absentDays;

                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          daysValidationError:
                            workingDays > 0 && totalDays > workingDays
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          workingDays:
                            formFields.workingDays && formFields.workingDays.length > 0
                              ? /^[0-9]+$/.test(formFields.workingDays)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Working Days",
                          daysValidationError:
                            parseFloat(formFields.workingDays) > 0 &&
                              parseFloat(formFields.presentDays) + parseFloat(formFields.leaveDays) + parseFloat(formFields.absentDays) >
                              parseFloat(formFields.workingDays)
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      errorMessage={formFieldsError.workingDays}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Present Days"}
                      name={"presentDays"}
                      classStar={"text-red-500"}
                      content={formFields.presentDays}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setFormFields({ ...formFields, presentDays: value });

                        // Validate days sum
                        const workingDays = parseFloat(formFields.workingDays) || 0;
                        const presentDays = parseFloat(value) || 0;
                        const leaveDays = parseFloat(formFields.leaveDays) || 0;
                        const absentDays = parseFloat(formFields.absentDays) || 0;
                        const totalDays = presentDays + leaveDays + absentDays;

                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          daysValidationError:
                            workingDays > 0 && totalDays > workingDays
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          presentDays:
                            formFields.presentDays && formFields.presentDays.length > 0
                              ? /^[0-9]+$/.test(formFields.presentDays)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Present Days",
                          daysValidationError:
                            parseFloat(formFields.workingDays) > 0 &&
                              parseFloat(formFields.presentDays) + parseFloat(formFields.leaveDays) + parseFloat(formFields.absentDays) >
                              parseFloat(formFields.workingDays)
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      errorMessage={formFieldsError.presentDays}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Leave Days"}
                      name={"leaveDays"}
                      classStar={"text-red-500"}
                      content={formFields.leaveDays}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setFormFields({ ...formFields, leaveDays: value });

                        // Validate days sum
                        const workingDays = parseFloat(formFields.workingDays) || 0;
                        const presentDays = parseFloat(formFields.presentDays) || 0;
                        const leaveDays = parseFloat(value) || 0;
                        const absentDays = parseFloat(formFields.absentDays) || 0;
                        const totalDays = presentDays + leaveDays + absentDays;

                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          daysValidationError:
                            workingDays > 0 && totalDays > workingDays
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          leaveDays:
                            formFields.leaveDays && formFields.leaveDays.length > 0
                              ? /^[0-9]+$/.test(formFields.leaveDays)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Leave Days",
                          daysValidationError:
                            parseFloat(formFields.workingDays) > 0 &&
                              parseFloat(formFields.presentDays) + parseFloat(formFields.leaveDays) + parseFloat(formFields.absentDays) >
                              parseFloat(formFields.workingDays)
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      errorMessage={formFieldsError.leaveDays}
                    />

                    <InputText
                      inputType={"number"}
                      title={"Absent Days"}
                      name={"absentDays"}
                      classStar={"text-red-500"}
                      content={formFields.absentDays}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setFormFields({ ...formFields, absentDays: value });

                        // Validate days sum
                        const workingDays = parseFloat(formFields.workingDays) || 0;
                        const presentDays = parseFloat(formFields.presentDays) || 0;
                        const leaveDays = parseFloat(formFields.leaveDays) || 0;
                        const absentDays = parseFloat(value) || 0;
                        const totalDays = presentDays + leaveDays + absentDays;

                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          daysValidationError:
                            workingDays > 0 && totalDays > workingDays
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      controlFuncBlur={() => {
                        setFormFieldsError((prevErrors) => ({
                          ...prevErrors,
                          absentDays:
                            formFields.absentDays && formFields.absentDays.length > 0
                              ? /^[0-9]+$/.test(formFields.absentDays)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Absent Days",
                          daysValidationError:
                            parseFloat(formFields.workingDays) > 0 &&
                              parseFloat(formFields.presentDays) + parseFloat(formFields.leaveDays) + parseFloat(formFields.absentDays) >
                              parseFloat(formFields.workingDays)
                              ? "Sum of Present Days, Leave Days, and Absent Days cannot exceed Working Days"
                              : "",
                        }));
                      }}
                      errorMessage={formFieldsError.absentDays}
                    />
                  </div>
                  {formFieldsError.daysValidationError && (
                    <div className="text-red-500 px-4 text-sm">
                      {formFieldsError.daysValidationError}
                    </div>
                  )}
                  <div className="font-semibold px-4">Total Salary Paid</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType={"number"}
                      title={"Amount to be Paid"}
                      name={"totalAmounttobePaid"}
                      classStar={"text-red-500"}
                      content={formFields.totalAmounttobePaid}
                      controlFunc={(e) =>
                        setFormFields({
                          ...formFields,
                          totalAmounttobePaid: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setFormFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          totalAmounttobePaid:
                            formFields.totalAmounttobePaid &&
                              formFields.totalAmounttobePaid.toString().trim() !== ""
                              ? /^[0-9]+$/.test(formFields.totalAmounttobePaid)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Amount",
                        }));
                      }}
                      errorMessage={formFieldsError.totalAmounttobePaid}
                      disabled={true}
                    />
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen}>
        <div>
          <PopUpScreenTitle
            title="Salary Paid"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <SalaryPaidPopup data={popUpData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default SalaryPaid;